import React from 'react'
import { t } from 'ttag'

import { Accordion } from 'components/shared/Accordion/Accordion'
import { AccordionContext } from 'components/shared/Accordion/context'
import HelpCardChevron from './HelpCardChevron'

const HelpTraitCardHeader = ({ icon, title, description }) => {
  const { handleToggle, isOpen } = React.useContext(AccordionContext)

  return (
    <button
      type="button"
      className="HelpTraitCard__header"
      onClick={handleToggle}
      aria-expanded={isOpen}
    >
      <span className="HelpTraitCard__icon">{icon}</span>
      <span className="HelpTraitCard__heading">
        <span className="HelpTraitCard__title">{title}</span>
        <span className="HelpTraitCard__description">{description}</span>
      </span>
      <HelpCardChevron />
    </button>
  )
}

const HelpTraitCard = ({
  icon,
  title,
  description,
  highScore,
  lowScore,
  facets,
  isInitiallyOpen = false,
}) => (
  <Accordion className="HelpTraitCard" isInitiallyOpen={isInitiallyOpen}>
    <HelpTraitCardHeader {...{ icon, title, description }} />
    <Accordion.Panel className="HelpTraitCard__panel">
      <div className="HelpTraitCard__scores">
        <div className="HelpTraitCard__score">
          <span className="HelpTraitCard__badge HelpTraitCard__badge--low">
            {t`Low score`}
          </span>
          <p>{lowScore}</p>
        </div>
        <div className="HelpTraitCard__score">
          <span className="HelpTraitCard__badge HelpTraitCard__badge--high">
            {t`High score`}
          </span>
          <p>{highScore}</p>
        </div>
      </div>
      <div className="HelpTraitCard__facets">
        <span className="HelpTraitCard__facetsLabel">{t`Facets`}</span>
        <ul className="HelpTraitCard__facetList">
          {facets.map(facet => (
            <li key={facet}>{facet}</li>
          ))}
        </ul>
      </div>
    </Accordion.Panel>
  </Accordion>
)

export default HelpTraitCard
